// Mexican states — these don't change between locales (proper nouns)
const states = [
  { value: 'aguascalientes', label: 'Aguascalientes' },
  { value: 'baja-california', label: 'Baja California' },
  { value: 'baja-california-sur', label: 'Baja California Sur' },
  { value: 'campeche', label: 'Campeche' },
  { value: 'chiapas', label: 'Chiapas' },
  { value: 'chihuahua', label: 'Chihuahua' },
  { value: 'cdmx', label: 'Ciudad de México' },
  { value: 'coahuila', label: 'Coahuila' },
  { value: 'colima', label: 'Colima' },
  { value: 'durango', label: 'Durango' },
  { value: 'estado-de-mexico', label: 'Estado de México' },
  { value: 'guanajuato', label: 'Guanajuato' },
  { value: 'guerrero', label: 'Guerrero' },
  { value: 'hidalgo', label: 'Hidalgo' },
  { value: 'jalisco', label: 'Jalisco' },
  { value: 'michoacan', label: 'Michoacán' },
  { value: 'morelos', label: 'Morelos' },
  { value: 'nayarit', label: 'Nayarit' },
  { value: 'nuevo-leon', label: 'Nuevo León' },
  { value: 'oaxaca', label: 'Oaxaca' },
  { value: 'puebla', label: 'Puebla' },
  { value: 'queretaro', label: 'Querétaro' },
  { value: 'quintana-roo', label: 'Quintana Roo' },
  { value: 'san-luis-potosi', label: 'San Luis Potosí' },
  { value: 'sinaloa', label: 'Sinaloa' },
  { value: 'sonora', label: 'Sonora' },
  { value: 'tabasco', label: 'Tabasco' },
  { value: 'tamaulipas', label: 'Tamaulipas' },
  { value: 'tlaxcala', label: 'Tlaxcala' },
  { value: 'veracruz', label: 'Veracruz' },
  { value: 'yucatan', label: 'Yucatán' },
  { value: 'zacatecas', label: 'Zacatecas' }
];

// Keep static exports for backward compat (used in API route)
export const contactOptions = [{ value: 'default', label: 'De dónde nos contactas' }, ...states];

export const budgetOptions = [
  { value: 'default', label: 'Presupuesto estimado' },
  { value: 'medium', label: '$1M-$3M' },
  { value: 'high', label: 'más de $3M' }
];

export const maritalStatusOptions = [
  { value: 'default', label: 'Estado civil' },
  { value: 'single', label: 'Soltero(a)' },
  { value: 'married', label: 'Casado(a)' },
  { value: 'widower', label: 'Viudo(a)' },
  { value: 'divorced', label: 'Divorciado(a)' },
  { value: 'de_facto_union', label: 'Unión de hecho' }
];

export const professionOptions = [
  { value: 'default', label: 'Profesión' },
  { value: 'bussiness', label: 'Empresario' },
  { value: 'independent', label: 'Profesionista Independiente' },
  { value: 'doctor', label: 'Médico' },
  { value: 'employee', label: 'Empleado' },
  { value: 'another', label: 'Otro' }
];

// Localized version — receives translator with namespace 'dataset'
export function getLocalizedDataset(t: (key: string) => string) {
  return {
    contactOptions: [{ value: 'default', label: t('contactDefault') }, ...states],
    budgetOptions: [
      { value: 'default', label: t('budgetDefault') },
      { value: 'medium', label: t('budgetMedium') },
      { value: 'high', label: t('budgetHigh') }
    ],
    maritalStatusOptions: [
      { value: 'default', label: t('maritalStatusDefault') },
      { value: 'single', label: t('single') },
      { value: 'married', label: t('married') },
      { value: 'widower', label: t('widower') },
      { value: 'divorced', label: t('divorced') },
      { value: 'de_facto_union', label: t('deFactoUnion') }
    ],
    professionOptions: [
      { value: 'default', label: t('professionDefault') },
      { value: 'bussiness', label: t('business') },
      { value: 'independent', label: t('independent') },
      { value: 'doctor', label: t('doctor') },
      { value: 'employee', label: t('employee') },
      { value: 'another', label: t('another') }
    ]
  };
}
